import { isNil } from 'lodash';
import { formatDateTimeWithYear, isDateString } from '@shared/util/date';
import { EditableField, Field } from './Field';

export class DateField implements EditableField {
  readonly date: string;
  readonly formattedDate: string | undefined;
  readonly fieldType = 'DateField';

  public constructor(date: string) {
    this.date = date;
    this.formattedDate = formatDateTimeWithYear(date);
  }

  validate(): string | null {
    return null;
  }

  isEqual(field: Field): boolean {
    return field instanceof DateField && this.date === field.date;
  }

  toFieldJson() {
    return this.date;
  }

  get isEmpty() {
    return isNil(this.formattedDate);
  }

  static fromFieldJson(jsonBlob: any): DateField | null {
    if (isDateString(jsonBlob)) {
      return new DateField(jsonBlob);
    } else {
      return null;
    }
  }
}

export function isDateField(field?: Field | null): field is DateField {
  return field instanceof DateField;
}
